import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-home-district-admin',
  template: `
    <p>
      home-district-admin works!
    </p>
  `,
  styles: []
})
export class HomeDistrictAdminComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
